import { createFileRoute } from '@tanstack/react-router';
import { loadShire, makeShireSubPageHead, type ShireLoaderData } from '../components/shared/shire-sub-route';
import { ShireSubPageShell } from '../components/shared/ShireSubPageShell';
import { ShireProfile } from '../components/shared/ShireProfile';
import { ShirePopulationChart } from '../components/shared/ShirePopulationChart';

export const Route = createFileRoute('/shire/$name_/profile')({
  loader: ({ params }) => loadShire(params.name),
  head: (ctx) =>
    makeShireSubPageHead(
      (ctx as { loaderData?: ShireLoaderData } | undefined)?.loaderData,
      'Community profile',
      'Census demographics, population trend and socioeconomic snapshot for this shire.',
    ),
  component: ProfilePage,
});

function ProfilePage() {
  const { shire } = Route.useLoaderData() as ShireLoaderData;
  return (
    <ShireSubPageShell
      shire={shire}
      eyebrow="Profile"
      title="Community profile"
      lede={`Census demographics and population trend for the Shire of ${shire.name}.`}
    >
      <ShireProfile shire={shire} />
      <ShirePopulationChart shireId={shire.id} shireName={shire.name} />
    </ShireSubPageShell>
  );
}
